import { render, staticRenderFns } from "./foreignEmployees.vue?vue&type=template&id=664852b3&"
import script from "./foreignEmployees.vue?vue&type=script&lang=js&"
export * from "./foreignEmployees.vue?vue&type=script&lang=js&"
import style0 from "./foreignEmployees.vue?vue&type=style&index=0&id=664852b3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports